import React, { type ReactNode } from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const knowledgeCardMediaStyles = cssMap({
	default: {
		borderRadius: token('radius.small'),
		borderWidth: '0',
		display: 'flex',
		alignItems: 'center',
	},
	compact: {
		height: '32px',
		width: '32px',
	},
	full: {
		height: '80px',
		width: '80px',
	},
});

type KnowledgeCardMediaProps = {
	children: ReactNode;
	size: 'full' | 'compact';
};

export const KnowledgeCardMedia = ({ children, size }: KnowledgeCardMediaProps) => {
	return (
		<Box
			xcss={cx(
				knowledgeCardMediaStyles.default,
				size === 'compact' ? knowledgeCardMediaStyles.compact : knowledgeCardMediaStyles.full,
			)}
		>
			{children}
		</Box>
	);
};
